
// import Accordion from './Accordion';
import BusRatesTable from './BusRatesTable';
// import CustomCarousel from './CustomCarousel';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import { Link } from 'react-router-dom';
// import FAQSection from './FAQSection';
import FAQItem from './FAQItem';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Punetomumbaiinternational() {



  const cardData =
  {
    keyword: 'Pune to Mumbai International Airport Cab Service',
    heading: 'AB Ghule Cabs: Pune to Mumbai International Airport Cab Service',
    headingDescription: 'AB Ghule Cabs offers convenient, reliable, and affordable Pune to Mumbai International Airport cab services. Whether you are catching a flight or arriving from the airport, our comfortable vehicles and professional drivers ensure a smooth and hassle-free ride. We offer punctual services, taking into consideration traffic conditions to ensure timely arrival at the airport. Pune to Mumbai International Airport is approximately 150 km.',

    top: 'Top Places to Visit Near Mumbai International Airport with AB Ghule Cabs',

    topPlaces: [
        {
          title: "Juhu Beach",
          description: "Located just 6-7 km from the airport, Juhu Beach is one of the most famous beaches in Mumbai. It’s perfect for a quick visit to enjoy the sea breeze, local snacks, and the vibrant atmosphere. The beach is also home to several iconic hotels and is a favorite for evening strolls, making it a perfect place to unwind before heading out to explore the city."
        },
        {
          title: "Bandra-Worli Sea Link",
          description: "A modern architectural marvel, the Bandra-Worli Sea Link offers stunning views of the sea and the city skyline. It’s a must-see landmark when traveling between South Mumbai and the western suburbs. The bridge is not only an engineering feat but also an excellent spot for a scenic drive or a photography session with the sunset over the Arabian Sea."
        },
        {
          title: "Gateway of India",
          description: "Situated about 20 km from the airport, the Gateway of India is an iconic historical monument overlooking the Arabian Sea. It’s a must-visit for anyone new to Mumbai, offering a picturesque view and a glimpse into the city’s colonial past. The monument also serves as a gateway for ferries heading to Elephanta Caves and other nearby attractions."
        },
        {
          title: "Chhatrapati Shivaji Maharaj Vastu Sangrahalaya",
          description: "A short drive from the airport, this museum is a treasure trove of Indian history and culture, showcasing artifacts from ancient, medieval, and modern India. With its vast collection of sculptures, paintings, and historical items, the museum is a great place to delve into the rich cultural heritage of Mumbai and India."
        },
        {
          title: "Marine Drive",
          description: "Known as the ‘Queen’s Necklace,’ Marine Drive offers a serene promenade along the Arabian Sea. It’s a great place to unwind and enjoy the stunning sunset views. The boulevard is lined with art deco buildings, and the area is famous for its peaceful ambiance, making it a popular spot for locals and tourists to relax."
        },
        {
          title: "Colaba Causeway",
          description: "Famous for its street shopping and vibrant atmosphere, Colaba Causeway is located about 20 km from the airport. It’s perfect for picking up souvenirs, fashion, and accessories. The market is lively and bustling, offering everything from trendy clothes to vintage items, and is a great spot to experience the city’s eclectic charm."
        },
        {
          title: "Elephanta Caves",
          description: "A UNESCO World Heritage site, the Elephanta Caves, located on Elephanta Island, are around 15 km away from the airport. A quick boat ride will take you to these historic rock-cut caves with intricate sculptures. The caves are a blend of art, history, and spirituality, offering a peaceful escape from the bustling city."
        },
        {
          title: "Haji Ali Dargah",
          description: "Haji Ali Dargah is an iconic mosque and tomb located on an island, accessible by a causeway from Worli. It is approximately 15 km from the airport and offers a peaceful, spiritual experience. The Dargah is not only a religious landmark but also an architectural marvel surrounded by the Arabian Sea, making it a serene place to reflect."
        },
        {
          title: "Siddhivinayak Temple",
          description: "Located around 12 km from the airport, Siddhivinayak Temple is one of Mumbai’s most famous temples dedicated to Lord Ganesha. It is a significant spiritual destination for devotees. The temple is known for its ornate architecture and rich history, and is visited by thousands of devotees seeking blessings from the revered deity."
        },
        {
          title: "Phoenix Marketcity",
          description: "For shopping lovers, Phoenix Marketcity is a large mall located around 7 km from the airport, featuring international brands, restaurants, and entertainment options. The mall is a modern retail haven, offering a wide array of shopping, dining, and entertainment choices, making it an ideal place to spend a few hours."
        }
      ],


      services: [
        {
          "name": "Pune to Mumbai International Airport Cab",
          description: "AB Ghule Cabs offers reliable and comfortable cab services for your journey from Pune to Mumbai International Airport. Whether you're flying for business or leisure, our experienced drivers will ensure that you reach the airport on time. We offer a range of vehicles to suit your travel needs."
        },
        {
          "name": "Pune to Mumbai Airport",
          description: "Traveling from Pune to Mumbai Airport has never been easier with AB Ghule Cabs. We offer efficient, punctual, and affordable taxi services, ensuring a smooth and stress-free ride to the airport. Book your cab with us for a hassle-free airport transfer."
        },
        {
          "name": "Mumbai International Airport to Pune Cab",
          description: "AB Ghule Cabs provides comfortable and affordable taxi services for your return journey from Mumbai International Airport to Pune. Our drivers are well-versed with the best routes, ensuring that you have a safe and pleasant ride back to Pune."
        },
        {
          "name": "Mumbai International Airport to Pune Cab Service",
          description: "Looking for a cab from Mumbai International Airport to Pune? AB Ghule Cabs offers reliable and affordable services for a comfortable journey back to Pune. With our well-maintained vehicles and professional drivers, you can be assured of a smooth ride."
        },
        {
          "name": "Pune to Chhatrapati Shivaji International Airport Cab",
          description: "Book a cab with AB Ghule Cabs for your trip from Pune to Chhatrapati Shivaji International Airport. Our taxis are comfortable and affordable, and we ensure that you reach the airport on time, stress-free. We offer both one-way and round-trip options."
        },
        {
          "name": "Pune to Mumbai Domestic Airport Cab",
          description: "If you're traveling to Mumbai’s Domestic Airport from Pune, AB Ghule Cabs provides excellent taxi services for your convenience. We offer punctual pick-ups, reliable drivers, and a comfortable ride to ensure you reach the airport on time."
        },
        {
          "name": "Taxi from Mumbai International Airport to Pune",
          description: "Book a taxi from Mumbai International Airport to Pune with AB Ghule Cabs for a comfortable and hassle-free ride. Our experienced drivers will ensure that you get to your destination safely and on time, with convenient pick-up points at the airport."
        },
        {
          "name": "Pune to Chhatrapati Shivaji International Airport Taxi",
          description: "AB Ghule Cabs offers reliable taxi services from Pune to Chhatrapati Shivaji International Airport, ensuring a smooth journey with no delays. We provide affordable pricing and a fleet of vehicles to accommodate your travel needs, whether you are traveling alone or in a group."
        },
        {
          "name": "Pune to Mumbai International Airport Innova Taxi",
          description: "If you're traveling in a group or with family, consider booking an Innova taxi for your trip from Pune to Mumbai International Airport. Our spacious and well-maintained Innova taxis ensure comfort, with enough room for luggage and a smooth, relaxing ride to the airport."
        },
        {
          "name": "Pune to Mumbai Drop Taxi",
          description: "AB Ghule Cabs offers a convenient drop taxi service from Pune to Mumbai, ensuring a safe, timely, and comfortable ride. Whether you're heading to the airport, a business meeting, or a leisure trip, our drop taxi service is the perfect choice for a hassle-free journey."
        },
        {
          "name": "Best Cab Service Pune to Mumbai",
          description: "For the best cab service from Pune to Mumbai, choose AB Ghule Cabs. Our professional drivers, reliable vehicles, and affordable pricing make us the preferred choice for travelers. Book your cab with us today for a safe and comfortable ride."
        },
        {
          "name": "Best Cab Service from Pune to Mumbai Airport",
          description: "AB Ghule Cabs is known for offering the best cab service from Pune to Mumbai Airport. With our punctuality, reliability, and a wide range of vehicles, we ensure that your airport transfer is smooth and stress-free."
        },
        {
          "name": "Pune to Mumbai Airport Cab Charges",
          description: "The cab charges for your Pune to Mumbai Airport journey with AB Ghule Cabs depend on factors like the type of vehicle, distance, and duration. Our pricing is transparent with no hidden charges, ensuring you get the best value for your money."
        },
        {
          "name": "Pune to Mumbai Airport Cab Booking",
          description: "Booking a cab from Pune to Mumbai Airport is easy with AB Ghule Cabs. Simply visit our website or call our customer support, and we’ll reserve your taxi in no time. We provide a variety of vehicle options to suit your preferences and needs."
        },
        {
          "name": "Book Your Pune to Mumbai Airport Cabs",
          description: "Book your Pune to Mumbai Airport cab with AB Ghule Cabs for a smooth and hassle-free experience. We offer reliable and comfortable rides, with experienced drivers ensuring your journey is pleasant and on time. Choose from a variety of vehicles based on your needs and group size."
        },
        {
          "name": "Pune to Mumbai International Airport Cab Contact Number",
          description: "Contact AB Ghule Cabs at +91 8624029699 for prompt and efficient Pune to Mumbai International Airport Cab. We ensure a smooth and enjoyable ride for all our customers."
        }
      ],

      tableData: [
        ["Pune to Mumbai International Airport Cab", "-Pune to Mumbai Airport"],
        ["Mumbai International Airport to Pune Cab", "-Mumbai international airport to Pune cab service"],
        ["Pune to Chhatrapati Shivaji International Airport Cab", "-Pune to Mumbai domestic airport cab"],
        ["Taxi from Mumbai International Airport to Pune", "-Pune to Chhatrapati Shivaji International Airport Taxi"],
        ["Pune to Mumbai International Airport Innova Taxi", "-Pune to Mumbai Drop Taxi"],
        ["Best Cab Service Pune to Mumbai", "-Best cab service from Pune to Mumbai Airport"],
        ["Pune to Mumbai Airport cab charges", "-Pune to Mumbai airport cab booking"],
        ["Book your Pune to Mumbai Airport Cabs", ""]
      ],
      
      whychoose: [
        {
          WhyChooseheading: "Reliable and Timely Service",
          WhyChoosedescription: "We understand the importance of reaching your flight on time. At AB Ghule Cabs, we guarantee reliable and timely pickups to ensure you reach Mumbai International Airport without any delays."
        },
        {
          WhyChooseheading: "Comfortable and Well-Maintained Vehicles",
          WhyChoosedescription: "Our fleet of vehicles is regularly maintained and cleaned to provide a comfortable and smooth ride. Whether you're traveling alone or with a group, we offer a range of vehicles to suit your needs, from budget-friendly options to luxury cars."
        },
        {
          WhyChooseheading: "Experienced and Professional Drivers",
          WhyChoosedescription: "Our drivers are well-trained, experienced, and familiar with the best routes from Pune to Mumbai International Airport. They are committed to your safety and will ensure a smooth and stress-free journey."
        },
        {
          WhyChooseheading: "Affordable and Transparent Pricing",
          WhyChoosedescription: "We offer competitive pricing with no hidden charges. Whether it's a one-way trip or round trip, our fare structure is clear and affordable, so you can plan your travel without any surprises."
        },
        {
          WhyChooseheading: "24/7 Availability",
          WhyChoosedescription: "Our services are available around the clock, so whether you have an early morning flight or a late-night arrival, AB Ghule Cabs is ready to provide reliable airport transportation whenever you need it."
        },
        {
          WhyChooseheading: "Easy Booking Process",
          WhyChoosedescription: "Booking a cab is quick and simple with AB Ghule Cabs. You can easily book through our website, mobile app, or by calling our customer service. We offer flexible options to suit your convenience."
        },
        {
          WhyChooseheading: "No Hidden Fees",
          WhyChoosedescription: "At AB Ghule Cabs, we believe in transparent pricing. The fare you see is the fare you pay. There are no hidden or surprise charges during your trip."
        }
      ]
      
  
  

  }

  const faqData = [
    {
      id: 'FAQ1',
      question: 'How can I book a cab from Pune to Mumbai International Airport?',
      answer: 'You can book a cab through our website, mobile app, or by calling our customer service helpline. Provide us with your travel details, and we will arrange a hassle-free ride for you.',
    },
    {
      id: 'FAQ2',
      question: 'How long does it take to travel from Pune to Mumbai International Airport?',
      answer: 'The travel time from Pune to Mumbai International Airport is typically around 2 to 3 hours, depending on traffic conditions. Our drivers take the best routes to ensure you reach the airport on time.',
    },
    {
      id: 'FAQ3',
      question: 'What types of vehicles are available for the trip?',
      answer: 'We offer a variety of vehicles for your airport trip, including sedans, SUVs, and luxury cars. We can recommend the best option based on the number of passengers and your preferences.',
    },
    {
      id: 'FAQ4',
      question: 'Are there any additional charges for tolls or parking fees?',
      answer: 'There may be additional charges for tolls or parking fees depending on the route and parking requirements at the airport. However, we provide a clear breakdown of all charges during the booking process.',
    },
    {
      id: 'FAQ5',
      question: 'How far in advance should I book a cab for the airport?',
      answer: 'We recommend booking your cab as soon as you have your flight details. While last-minute bookings are possible, advance booking ensures availability and a smoother experience.',
    },
    {
      id: 'FAQ6',
      question: 'Can I request a specific vehicle for the trip?',
      answer: 'Yes, you can request a specific vehicle based on availability. Whether you prefer a sedan or an SUV, we will do our best to accommodate your request.',
    },
    {
      id: 'FAQ7',
      question: 'Can I book a return trip from Mumbai International Airport to Pune?',
      answer: 'Yes, we offer round-trip services. You can book your cab for both the onward and return journeys at the time of your initial booking.',
    },
    {
      id: 'FAQ8',
      question: 'What happens if my flight is delayed?',
      answer: 'Our drivers track your flight and adjust the pickup time accordingly to accommodate delays, ensuring you don’t have to worry about missing your cab.',
    },
    {
      id: 'FAQ9',
      question: 'How can I pay for my cab ride?',
      answer: 'You can pay for your ride via cash, credit/debit card, or online payment through our mobile app, offering you multiple options for convenience.',
    },
    {
      id: 'FAQ10',
      question: 'What makes AB Ghule Cabs the best choice for airport transportation?',
      answer: 'AB Ghule Cabs is committed to providing a reliable, comfortable, and affordable service with experienced drivers and a fleet of well-maintained vehicles. Our 24/7 availability, transparent pricing, and focus on customer satisfaction make us the best choice for your Pune to Mumbai International Airport ride.',
    },
  ];
  
  const testimonials = [
    {
      id: 1,
      name: 'Mr. Arvind Deshmukh',
      feedback: 'I booked a cab with AB Ghule Cabs for my flight from Pune to Mumbai International Airport, and I was extremely impressed with their service. The driver was punctual, the car was clean and comfortable, and I arrived at the airport on time with no hassle. I’ll definitely use them again for my airport rides!',
      rating: 5,
    },
    {
      id: 2,
      name: 'Ms. Neha Patel',
      feedback: 'I’ve used AB Ghule Cabs several times for my airport trips, and they never disappoint. The booking process is quick and easy, the drivers are always professional, and the pricing is very reasonable. Highly recommend them for anyone traveling between Pune and Mumbai Airport.',
      rating: 5,
    },
  ];
  
  
  






  const carouselItems = testimonials.map(testimonial => (
    <div key={testimonial.name}>
      <blockquote>

        <p className='testi'>   <span className="quote">“</span>{testimonial.text}</p>
        <footer className=' user'>— {testimonial.name}</footer>
      </blockquote>
    </div>
  ));

  const carouselOptions = {
    loop: true,
    margin: 10,
    nav: true,
    items: 1
  };

  const contactData = {
    heading: `${cardData.keyword} Contact Number`,
    contactNumbers: [
      "+91 8624029699",
      

    ],
    email: "booking@abghulecabs.com"
  };


  const Images = [
    {
      place: "/images/keyword/1.jpg",
      text: "Mumbai Cab Service",
    },
    {
      place: "/images/keyword/2.jpg",
      text: "Mumbai to Shirdi Cab",
    },
    {
      place: "/images/keyword/3.jpg",
      text: "Mumbai Darshan Cabs",
    },
    {
      place: "/images/keyword/4.jpg",
      text: "Mumbai to Vadodara Taxi",
    },
    {
      place: "/images/keyword/5.jpg",
      text: "Mumbai to Pune Cab",
    },
    {
      place: "/images/keyword/6.jpg",
      text: " Mumbai to Goa Taxi",
    },
    {
      place: "/images/keyword/7.jpg",
      text: "Mumbai Airport Cab",
    },

    {
      place: "/images/keyword/8.jpg",
      text: "Mumbai Surat Cabs",
    },

    {
      place: "/images/keyword/9.jpg",
      text: "Mumbai to Mahabaleshwar Cab",
    },
    {
      place: "/images/keyword/10.jpg",
      text: "Mumbai to Konkan Cab",
    },

    {
      place: "/images/keyword/11.jpg",
      text: "Pune Cab Service",
    },
    {
      place: "/images/keyword/12.jpg",
      text: "Pune Taxi Hire",
    },

    {
      place: "/images/keyword/13.jpg",
      text: "Pune Online Cab Booking",
    },

    {
      place: "/images/keyword/14.jpg",
      text: "Best Cab Service in Pune",
    },
    {
      place: "/images/keyword/15.jpg",
      text: "Pune to Mumbai Cabs",
    },
    {
      place: "/images/keyword/16.jpg",
      text: "Pune to Nashik Cabs",
    },
    {
      place: "/images/keyword/17.jpg",
      text: "Pune to Mahabaleshwar Cabs",
    },
    {
      place: "/images/keyword/18.jpg",
      text: "Pune to Lonavala Cabs",
    },
    {
      place: "/images/keyword/19.jpg",
      text: "Pune to Shirdi Cab",
    },
    {
      place: "/images/keyword/20.jpg",
      text: "Pune to Lavasa city cabs",
    },
    {
      place: "/images/keyword/21.jpg",
      text: "Pune to Bhimashankar Cab",
    },
    {
      place: "/images/keyword/22.jpg",
      text: "Pune to Indore Cabs",
    },
    {
      place: "/images/keyword/23.jpg",
      text: "Pune to Konkan Darshan Cabs",
    },
    {
      place: "/images/keyword/24.jpg",
      text: "Pune Outstation Cabs",
    },
    {
      place: "/images/keyword/25.jpg",
      text: "Pune to Panchgani Cab Fare",
    },
    {
      place: "/images/keyword/26.jpg",
      text: "Pune to Mumbai International Airport Cab",
    },
    {
      place: "/images/keyword/27.jpg",
      text: "Ashtavinayak Darshan Cab",
    },
  ];


  const images = [
    { src: "/images/our-fleet/1.jpg", alt: "Image 1" },
    { src: "/images/our-fleet/2.jpg", alt: "Image 2" },
    { src: "/images/our-fleet/3.jpg", alt: "Image 3" },
    { src: "/images/our-fleet/4.jpg", alt: "Image 4" },
    { src: "/images/our-fleet/5.jpg", alt: "Image 5" },
    { src: "/images/our-fleet/6.jpg", alt: "Image 6" },
    { src: "/images/our-fleet/7.jpg", alt: "Image 7" },
    { src: "/images/our-fleet/8.jpg", alt: "Image 8" },
    { src: "/images/our-fleet/9.jpg", alt: "Image 9" },
  ];





  return (
    <div>
      <Helmet>
  <title>Contact: +91 8624029699 | AB Ghule Cabs | Pune to Mumbai International Airport Cab | Affordable Taxi Booking & Car Rental Services | AB Ghule Cabs</title>
  <meta name="description" content="Book affordable Pune to Mumbai International Airport Cab with AB Ghule Cabs. Offering reliable airport transfers, luxury taxis, and one-way or round-trip services from Pune to Mumbai Airport. Call +91 8624029699 for bookings." />
  <meta name="keywords" content="Pune to Mumbai International Airport Cab, Pune to Mumbai Airport, Mumbai International Airport to Pune Cab, mumbai international airport to pune cab service, Pune to chhatrapati shivaji international airport cab, Pune to mumbai domestic airport cab, Taxi from Mumbai International Airport to Pune, Pune to Chhatrapati Shivaji International Airport Taxi, Pune to Mumbai International Airport Innova Taxi, Pune to Mumbai Drop Taxi, Best Cab Service Pune to Mumbai, Best cab service from Pune to Mumbai Airport, Pune to Mumbai Airport cab charges, Pune to mumbai airport cab booking, Book your Pune to Mumbai Airport Cabs" />
  <meta name="robots" content="index, follow" />
  <meta property="og:title" content="Contact: +91 8624029699 | AB Ghule Cabs | Pune to Mumbai International Airport Cab | Affordable Taxi Booking & Car Rental Services | AB Ghule Cabs" />
  <meta property="og:description" content="Book affordable Pune to Mumbai International Airport Cab with AB Ghule Cabs. Offering reliable airport transfers, luxury taxis, and one-way or round-trip services from Pune to Mumbai Airport. Call +91 8624029699 for bookings." />
  <meta property="og:image" content="https://abghulecabs.com/images/pune-to-mumbai-international-airport-cab.jpg" />
  <meta property="og:url" content="https://abghulecabs.com/pune-to-mumbai-international-airport-cab" />
  <meta property="og:type" content="website" />
  <meta property="og:site_name" content="AB Ghule Cabs" />

  {/* JSON-LD Structured Data for Schema Markup */}
  <script type="application/ld+json">
    {`
      {
        "@context": "https://schema.org",
        "@type": "LocalBusiness",
        "name": "AB Ghule Cabs - Pune to Mumbai International Airport Cab",
        description: "Book affordable Pune to Mumbai International Airport Cab with AB Ghule Cabs. Offering reliable airport transfers, luxury taxis, and one-way or round-trip services from Pune to Mumbai Airport. Call +91 8624029699 for bookings.",
        "address": {
          "@type": "PostalAddress",
          "streetAddress": "Pune, Maharashtra",
          "addressLocality": "Pune",
          "addressRegion": "Maharashtra",
          "postalCode": "411001",
          "addressCountry": "IN"
        },
        "telephone": "+91-8624029699",
        "url": "https://abghulecabs.com/pune-to-mumbai-international-airport-cab",
        "logo": "https://abghulecabs.com/images/pune-to-mumbai-international-airport-cab.jpg",
        "image": "https://abghulecabs.com/images/pune-to-mumbai-international-airport-cab.jpg",
        "priceRange": "₹1200 - ₹4000",
        "offers": {
          "@type": "Offer",
          "url": "https://abghulecabs.com/pune-to-mumbai-international-airport-cab",
          "priceCurrency": "INR",
          "price": "1200",
          "priceValidUntil": "2024-12-31"
        },
        "aggregateRating": {
          "@type": "AggregateRating",
          "ratingValue": "4.9",
          "reviewCount": "200"
        },
        "review": [
          {
            "@type": "Review",
            "author": {
              "@type": "Person",
              "name": "Suman Shah"
            },
            "datePublished": "2024-11-10",
            "reviewBody": "Great service and punctuality! The driver was professional and the car was clean. Highly recommend AB Ghule Cabs for airport transfers."
          },
          {
            "@type": "Review",
            "author": {
              "@type": "Person",
              "name": "Vikram Desai"
            },
            "datePublished": "2024-09-18",
            "reviewBody": "Booked a cab for Mumbai Airport drop. The ride was smooth and affordable. Excellent service!"
          }
        ],
        "serviceArea": {
          "@type": "Place",
          "name": "Pune to Mumbai International Airport",
          "geo": {
            "@type": "GeoCoordinates",
            "latitude": "18.5210",
            "longitude": "73.8558"
          }
        },
        "availableChannel": {
          "@type": "ServiceChannel",
          "serviceUrl": "https://abghulecabs.com/pune-to-mumbai-international-airport-cab"
        },
        "keywords": "Pune to Mumbai International Airport Cab, Pune to Mumbai Airport, Mumbai International Airport to Pune Cab, mumbai international airport to pune cab service, Pune to chhatrapati shivaji international airport cab, Pune to mumbai domestic airport cab, Taxi from Mumbai International Airport to Pune, Pune to Chhatrapati Shivaji International Airport Taxi, Pune to Mumbai International Airport Innova Taxi, Pune to Mumbai Drop Taxi, Best Cab Service Pune to Mumbai, Best cab service from Pune to Mumbai Airport, Pune to Mumbai Airport cab charges, Pune to mumbai airport cab booking, Book your Pune to Mumbai Airport Cabs"
      }
    `}
  </script>
</Helmet>

      <section id="about" className="jarallax text-light">
        <div className="center-y relative text-center">
          <div className="container">
            <div className="row">
              <div className="col-md-12 text-center">
                <h1 className='text-white'>{cardData.keyword}</h1>
              </div>
              <div className="clearfix"></div>
            </div>
          </div>
        </div>
      </section>

      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 ">
              <img src='/images/keyword/26.jpg' alt='img' />
              <h3 className="py-1"
                style={{
                  color: '#FF4101', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="">
                <p className='fw-bold py-3 darkcolor'>{cardData.top}</p>
                {cardData.topPlaces.map((place, index) => (
                  <div key={index} className="">
                    <div
                      style={{
                        cursor: 'pointer',
                        padding: '10px',
                        marginBottom: '7px',
                        borderRadius: '8px',
                        transition: 'transform 0.2s'
                      }}

                    >
                      <h4 className="mb-1 darkcolor">{place.title}</h4>
                      <p className="mb-0">{place.description}</p>
                    </div>
                  </div>
                ))}
              </div>
              <div
                style={{
                  cursor: 'pointer',
                  padding: '10px',
                  marginBottom: '7px',
                  borderRadius: '8px', // Optional: rounded corners
                  transition: 'transform 0.2s' // Optional: smooth scaling effect
                }}
              >
                {cardData.services.map((service, index) => (
                  <div key={index} className=" my-4">
                    <h4 className="py-1 darkcolor">{service.name}</h4>
                    <p>{service.description}</p>
                  </div>
                ))}
              </div>

              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable />

              <div id="why-choose-section"
                className='px-2'>
                {cardData.whychoose.map((item, index) => (
                  <div key={index}>
                    <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                    <p>{item.WhyChoosedescription}</p>
                  </div>
                ))}
              </div>


              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Ab Ghule Cabs</h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        {faqData.map((faq) => (
                          <FAQItem key={faq.id} id={faq.id} question={faq.question} answer={faq.answer} />
                        ))}
                      </div>
                    </div>
                  </div>
                </div>
              </div>


              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <div>

                <div className="contact-box Borderr">
                  <h3>{contactData.heading}</h3>
                  <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                  <div className="contact-details">
                    <p><strong className='darkcolor'>Mobile No:</strong></p>
                    <ul>
                      {contactData.contactNumbers.map((number, index) => (
                        <li key={index}>
                          <a href={`tel:${number}`} className="contact-link fw-bold fs-5">
                            {number}
                          </a>
                        </li>
                      ))}
                    </ul>
                    <p><strong className='darkcolor'>Email Id: </strong>
                      <a href={`mailto:${contactData.email}`} className="contact-link">
                        {contactData.email}
                      </a>
                    </p>
                  </div>
                </div>
              </div>
            </div>

            <div className='col-12 col-md-4' >
              {Images.map((e) => {
                return (
                  <div className="box1">
                    <a
                      href="./"
                      className="d-flex justify-content-around align-items-center"
                    >
                      <div className="b1">
                        <img src={e.place} alt="img" />
                      </div>
                      <div className="b2">
                        {" "}
                        <a href="./" className='px-3'>{e.text}</a>
                      </div>
                    </a>
                  </div>
                );
              })}


              <div className="gallery-container">
                <h2 className="gallery-title">Our Fleets</h2>
                <div className="gallery-row d-flex flex-wrap">
                  {images.map((image, index) => (
                    <div className="gallery-item col-md-4" key={index}>
                      <img
                        src={image.src}
                        alt={image.alt}
                        className="gallery-image"

                      />
                    </div>
                  ))}
                  {/* <Link to='/gallery' className=' border radius-5 bg-redd p-3 text-white rounded-5 '>
                    See Gallery
                  </Link> */}
                </div>
              </div>

              <div className=" rounded p-4 shadow-sm Uni_border "
                style={{
                  cursor: 'pointer',
                  padding: '10px',
                  border: '3px dotted #FF4101',
                  marginBottom: '7px',
                  fontWeight: 'bold',
                }}

              >
                <h4 className="pb-3 pt-3 lead fw-bold text-dark">Contact Information</h4>

                <div className="row">

                  <div className="col-12 mb-3">
                    <div className="Small_border  rounded text-center py-2 " style={{ backgroundColor: '#FF4101' }}>
                      <h4 className=" lead fw-semibold whitt text-dark">Phone Numbers</h4>
                      <i className="bi bi-telephone-fill fs-1 mb-2"></i>
                      <div className=''>
                        <a href="tel:+91 8624029699" className="d-block  text-white">+91 8624029699</a>
                        

                      </div>
                    </div>
                  </div>


                  <div className="col-12 mb-3 ">
                    <div className="Small_border rounded text-center">
                      <i className="bi bi-envelope fs-1 mb-2"></i>
                      <div className='rounded py-2' style={{ backgroundColor: '#FF4101' }}>
                        <h4 className=" fw-semibold lead whitt text-dark">Email</h4>
                        <a href="mailto:booking@abghulecabs.com" className=" text-white d-block">
                          booking@abghulecabs.com
                        </a>
                      </div>
                    </div>
                  </div>


                  <div className="col-12 mb-3 ">
                    <div className="Small_border  rounded text-center">
                      <i className="bi bi-house-fill fs-1 mb-2"></i>
                      <div className='rounded py-2' style={{ backgroundColor: '#FF4101' }}>
                        <h4 className=" fw-semibold lead whitt text-dark">Address</h4>
                        <p className="whit text-white ">
                          <i> AB Ghule Cabs<br />
                            R -10 Office No -1606,   <br />
                            Life Republic Mulshi, Marunji  <br />
                            Pune, Maharashtra - 411057.

                          </i>
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>



            </div>
          </div>
        </div>
      </section>






    </div>
  );
}

export default Punetomumbaiinternational;